<myarvato-title [darkMode]="false" [searchbar]="true" [big]="true" [title]="'pages.transport.tracking-list.title' | translate">
  @if (featureFlagTransportSearch) {
    <myarvato-fake-searchbar
      searchbar
      [placeholder]="'pages.transport.tracking-list.search-placeholder' | translate"
      (OnClick)="onSearchbarClick()"
    ></myarvato-fake-searchbar>
  }
</myarvato-title>

<div class="container--full-width">
  <div class="row mb--16">
    <div class="col-12">
      <myarvato-tree-table
        data-clarity-mask="true"
        [data]="treeData()"
        [columns]="selectedColumns()"
        [totalRecords]="treeTotalRecords()"
        (tableLazyLoaded)="onTableLazyLoaded($event)"
        (tableColumnReordered)="onTableColumnReordered($event)"
        [pageSizes]="[10, 25, 50]"
        [pageRowsPerPage]="25"
        [savePageSize]="'transport-tracking-list-table'"
        [pagination]="true"
        (rowSelected)="onRowSelected($event)"
        [(resetTableTrigger)]="resetTable"
        [(manualLazyLoadTrigger)]="manualLazyLoad"
        (emptyStateFilterReset)="onResetTable()"
        [initialSortField]="defaultSortField"
        [initialSortOrder]="defaultSortOrder"
      >
        <ng-template #tableTop>
          <div class="row">
            <div class="col-12 d-flex flex-row justify-content-between mb--8">
              <myarvato-calendar [(dateRange)]="selectedDateRange" display="button"></myarvato-calendar>

              <div class="d-flex flex-row justify-content-end gap-3">
                <transport-manage-kpi-bar [categoryTracker]="'Tracking List'"></transport-manage-kpi-bar>
                <myarvato-column-manager
                  [columns]="availableColumns()"
                  [(selectedColumns)]="selectedColumns"
                  [categoryTracker]="matomoTrackerCategory"
                  [defaultSelectedColumns]="defaultSelectedColumns"
                  [dataKey]="'fieldsIdentifier'"
                  [optionLabel]="'header'"
                ></myarvato-column-manager>
                <p-button
                  icon="pi pi-refresh"
                  (onClick)="onResetTable()"
                  [label]="'pages.transport.tracking-list.reset-view' | translate"
                  styleClass="mr--4"
                  variant="text"
                  [matomoClickCategory]="matomoTrackerCategory"
                  matomoClickAction="Clear View"
                  matomoClickName="Button Click"
                  aria-label="'pages.transport.tracking-list.reset-view' | translate"
                />
                <div>
                  <p-button
                    icon="pi pi-save"
                    (onClick)="openSaveViewDialog()"
                    [label]="'pages.transport.tracking-list.save-view' | translate"
                    variant="text"
                    styleClass="mr--4"
                    [matomoClickCategory]="matomoTrackerCategory"
                    matomoClickAction="Save View"
                    matomoClickName="Button Click"
                    aria-label="'pages.transport.tracking-list.save-view' | translate"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #tableCaption>
          <div class="row">
            <div class="col-12 d-flex justify-content-between align-items-center">
              <myarvato-kpi-bar
                [kpiCardDefinitions]="kpiCardDefinitions()"
                [kpiData]="kpiBarData()"
                [isLoading]="kpiBarLoading()"
                [skeletonCount]="3"
                (kpiCardClicked)="onKpiCardClicked($event)"
                [activeFilter]="treeLastFilter()"
              ></myarvato-kpi-bar>

              <myarvato-view-manager></myarvato-view-manager>
            </div>
          </div>
        </ng-template>

        @if (errorMessage(); as error) {
          <ng-template #tableEmptyMessage>
            <myarvato-error-message [details]="error.detail" [summary]="error.summary" />
          </ng-template>
        }
      </myarvato-tree-table>
    </div>
  </div>

  @if (!errorMessage()) {
    <div class="row mb--64">
      <div class="d-flex justify-content-end gap-2">
        <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
        <p-button (onClick)="menu.toggle($event)" severity="secondary" variant="text">
          <i class="pi pi-download"></i>
          {{ 'pages.transport.tracking-list.download.download-data' | translate }}
          <i class="pi pi-chevron-down ml--8"></i>
        </p-button>
      </div>
    </div>
  }
</div>

<ng-template #searchDialogRowTemplate let-item>
  <div>{{ item.trackingNumber }} • {{ item.shipToName1 }}, {{ item.shipToStreet }}, {{ item.shipToCity }}</div>
</ng-template>
